<template>
    <div class="container pwdPage">
        <div class="login-wrapper">
            <div class="header">系统登录</div>
            <div class="form-wrapper">
                <input type="text" style="width:calc(100% - 50px);" @input="updateInputValue" name="username" placeholder="用户名"  v-model="LoginDto.username"  class="input-item">
                <div style="overflow:hidden;">
                    <input style="width:calc(100% - 52px); float:left;" :type="pwdModel" name="password" placeholder="密码"  v-model="LoginDto.password"  class="input-item">
                    <i :class="'show fa fa-eye '+ showActive" @click="hidePwd()"></i>
                    <i :class="'hide fa fa-eye-slash '+ hideActive" @click="showPwd()"></i>
                </div>
                
                <div class="btn"  style="width:calc(100% - 50px);" @click="submit">登录</div>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name:'LoginPage',
    data () {
        return {
            code:"",
            // 登陆表单
            LoginDto:{
                username:'',
                password:'',
            },
            showActive: '',
            hideActive: 'active',
            pwdModel: 'password'
        }
    },
    created () {
    },
    methods: {
        updateInputValue(event) {
            if(event.target.value=="")
            {
                this.LoginDto.password=""
            }
        },
        showPwd:function(){
            this.showActive = 'active'
            this.hideActive = ''
            this.pwdModel = 'text'
        },
        hidePwd:function(){
            this.showActive = ''
            this.hideActive = 'active'
            this.pwdModel = 'password'
        },
        // 登录
        submit: function () {
            // 点击登陆向后台提交登陆信息
            if(this.LoginDto.username==undefined||this.LoginDto.username=="")
            {
                alert("请填写用户名！")
                return;
            }
            if(this.LoginDto.password==undefined||this.LoginDto.password=="")
            {
                alert("请填写密码！")
                return;
            }
            if(!(this.LoginDto.username.length>=5&&this.LoginDto.username.length<=12)){
                alert("请输入5-12位的用户名");
                return;
            }
            if(!(this.LoginDto.password.length>=6&&this.LoginDto.password.length<=12)){
                alert("请输入6-12位的密码");
                return;
            }
                        
            var ths = this
            ths.$post('/auth/login',this.LoginDto)
            .then(function (res) {
                alert(res.msg);
                if(res.success){
                    var userInfo = res.data;
                    var token = res.data.token;
                    ths.$store.dispatch('login', { userInfo, token});
                    ths.$router.push('/admin/AdminsList');
                }else{
                }
            })
            .catch(function (err) {
                console.log(err)
            })          
        },
    }
}
</script>

<style scoped>

html {
    height: 100%;
}
body {
    height: 100%;
}
.container {
    height: 100vh;
    width: 100%;
    background-image: URL('../../assets/bg2.jpg');
    background-size:100% 100%;
    background-attachment:fixed;
}
.login-wrapper {
    background-color: rgba(255,255,255,.5);
    width: 358px;
    height: 300px;
    border-radius: 15px;
    padding: 0 30px;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
}
.header {
    font-size: 20px;
    text-align: center;
    line-height: 100px;
}
.input-item {
    display: block;
    width: 100%;
    margin-bottom: 20px;
    border: 0;
    padding: 10px;
    border: 1px solid #ccc;
    font-size: 15px;
    outline: none;
}
.input-item:placeholder {
    text-transform: uppercase;
}
.btn {
    text-align: center;
    padding: 8px;
    margin: 0 auto;
    width: 100%;
    background: #46a6ff;
    color: #fff;
    font-size:14px;
}
.msg {
    text-align: center;
    line-height: 88px;
}
a {
    text-decoration-line: none;
    color: #abc1ee;
}
.item {
    display: flex;
    padding-bottom: 5px;
    display: flex;

}
.f-text {
    color: #484848;
    font-weight: 400;
    width: 70px;
    font-size: 16px;
    text-align: left;
    i {
        position: relative;
        top: -1px;
        right: 5px;
    }
}
.f-input {
    border: 0px;
    flex: 1;
    display: block;
    width: 90%;
    margin-bottom: 20px;
    border: 0;
    padding: 10px;
    border-bottom: 1px solid rgb(128, 125, 125);
    font-size: 15px;
    outline: none;
}
/* .code {
    position: relative;
    cursor: pointer;
    top: -5px;
    width: 74px;
    border: 1px solid #fdfdfd;
    border-radius: 2px;
    height: 35px;
    margin-left: 10px;
} */
.linkbt {
    color: #7ac2ff;
    text-decoration: underline;
    font-size: 0.5em;
}
.code {
    display: inline-block;
    background-color: #a3d0fe;
    color: #0f5197;
    width: 70px ;
    font-size: 1.4em;
    font-style: oblique;
    padding: 0px 10px 0px 10px;
    margin-left: auto;
}
.vcode-right{
    width: 100% ;
    margin: auto;
}


.pwdPage .fa{
  display:none;
  font-size:16px;
  width:30px;
  text-align:center;
  float:right;
  line-height:40px;
  cursor:pointer;
}
.pwdPage .fa.active{
  display:block;
}
.pwdPage .fa:hover{
  color:red;
}
</style>
